<template>
	<div>
		<Header></Header>
		<div
			id="demo"
			:class="[{ collapsed: collapsed }, { onmobile: isOnMobile }]"
		>
			<div class="demo">
				<div class="container">
					<router-view />
				</div>
				
				
				<sidebar-menu
					id="sidebarParent"
					:menu="menu"
					:rtl="true"
					width="250px"
					class="pt-2 mt-6 pb-5"
					:collapsed="collapsed"
					@toggle-collapse="onToggleCollapse"
					@item-click="onItemClick"
				/>
				
				
				<div
					v-if="isOnMobile && !collapsed"
					class="sidebar-overlay"
					@click="collapsed = true"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../components/shared/HeaderCostumer";
	import { SidebarMenu } from "vue-sidebar-menu";

	export default {
		name: "App",
		created()
		{
			window.addEventListener('scroll', this.handleScroll);
		},
		data() {
			return {
				 
				menu: [
					//{
					//   header: true,
					//   title: "Main Navigation",
					//   hiddenOnCollapse: true
					//},
					{
						href: "/customer",
						title: this.$t("sidebar.userInfo"),
						icon: "fas fa-info",
						child: [
							{
								href: "/customer/identityInfo",
								title: this.$t("sidebar.identityInfo")
							},
							{
								href: "/customer/residentialInfo",
								title: this.$t("sidebar.residentialInfo")
							},
							{
								href: "/customer/userStatus",
								title: this.$t("sidebar.userStatus")
							}
						]
						// child: [
						//   {
						//     href: "/customer/edit",
						//     title: this.$t("sidebar.editIdenticalUser"),
						//   },
						// ],
					},
					//================================== EDIT ==================================
					{
						href: "",
						title: this.$t("sidebar.editUser"),
						icon: "fas fa-edit",
						child: [
							{
								href: "/customer/editIdentityInfo",
								title: this.$t("sidebar.editIdenticalUser")
							},
							
							{
								href: "/customer/editResidentialInfo",
								title: this.$t("sidebar.editResidentialInfo")
							},
							
							{
								href: "/customer/editJobInfo",
								title: this.$t("sidebar.editJobInfo")
							},
							{
								href: "/customer/setTheLevel",
								title: this.$t("sidebar.setLevel")
							},

							{
								// href: "/customer/first-surety-data",
								href:"",
								title: this.$t("sidebar.firstSuretyInformation"),
								child:[
									{
									href: "/customer/firstSuretyIdentityInfo",
									title: this.$t("sidebar.identityInfo")
									},
									{
									href: "/customer/firstSuretyResidentialInfo",
									title: this.$t("sidebar.residentialInfo")
									},
									{
									href: "/customer/firstSuretyJobInfo",
									title: this.$t("sidebar.jobInfo")
									}
								]
							},
							{
								href: "",
								title: this.$t("sidebar.secondSurtyInformation"),
								child:[
									{
									href: "/customer/secondSuretyIdentityInfo",
									title: this.$t("sidebar.identityInfo")
									},
									{
									href: "/customer/secondSuretyResidentialInfo",
									title: this.$t("sidebar.residentialInfo")
									},
									{
									href: "/customer/secondSuretyJobInfo",
									title: this.$t("sidebar.jobInfo")
									}
								]
							}
						]
					},
					//=============================== UPLOAD DOCS ===============================
					{
						href: "",
						title: this.$t("sidebar.uploadDocuments"),
						icon: "fas fa-upload",
						child: [
							{
								href: "/customer/upload-user-docs",
								title: this.$t("sidebar.residencyDocuments")
							},
							{
								href: "/customer/upload-first-surty-docs",
								title: this.$t("sidebar.firstSurtyDocs")
							},
							{
								href: "/customer/upload-second-surty-docs",
								title: this.$t("sidebar.secondSurtyDocs")
							}
						]
					},

					//=============================== facilities =================================

					// {
					// 	href: "/customer",
					// 	title: this.$t("sidebar.facilities"),
					// 	icon: "fas fa-money-bill-wave",
					// 	child: [
					// 		{
					// 			href: "/customer/summery",
					// 			title: this.$t("sidebar.buySummery")
					// 		},
					// 		{
					// 			href: "/customer/installments",
					// 			title: this.$t("sidebar.installmentTable")
					// 		}
					// 	]
					// },

					//========================= SET LEVEL ============================
					// {
					// 	//href: "/customer/set-level",
					// 	title: this.$t("sidebar.creditLimit"),
					// 	icon: "fa fa-dollar-sign",
					// 	child: [
					// 		{
					// 			href: "/customer/set-level",
					// 			title: this.$t("sidebar.changeCreditLimit")
					// 		}
					// 		// {
					// 		//   href: "/register",
					// 		//   title: this.$t("sidebar.uploadCreditLimit")
					// 		// }
					// 	]
					// },

					//========================= CONTRACTS ============================
					{
						href: "/customer/contracts",
						title: this.$t("sidebar.contractsSummery"),
						icon: "fa fa-file-contract",

						child: [
							{
								href: "/customer/contracts",
								title: this.$t("sidebar.contracts")
							}
							
						]
					}

					//======================== SUPLLIERS =============================
					// {
					//   title: "فروشندگان",
					//   icon: "fa fa-dollar-sign",
					//   child: [
					//     {
					//       href: "/customer/set-level",
					//       title: this.$t("sidebar.changeCreditLimit"),
					//     },
					//     // {
					//     //   href: "/register",
					//     //   title: this.$t("sidebar.uploadCreditLimit")
					//     // }
					//   ],
					// },
				],
				collapsed: false,
				isOnMobile: false
			};
		},
		mounted() {
			this.onResize();
			
			window.addEventListener("resize", this.onResize);
		},
		methods: {
			handleScroll()
			{
				
				if(this.isOnMobile && window.pageYOffset>33)
				{
					document.getElementById('sidebarParent').classList.replace('mt-6','mt-0')
				}
				if(this.isOnMobile && window.pageYOffset<33)
				{
					document.getElementById('sidebarParent').classList.replace('mt-0','mt-6')
				}
				
			},
			onToggleCollapse(collapsed) {
				console.log(collapsed);
				this.collapsed = collapsed;
			},
			// eslint-disable-next-line no-unused-vars
			onItemClick(event, item, node) {
				console.log("onItemClick");
				// console.log(event)
				// console.log(item)
				// console.log(node)
			},
			onResize() {
				if (window.innerWidth <= 767) {
					this.isOnMobile = true;
					this.collapsed = true;
				} else {
					this.isOnMobile = false;
					this.collapsed = false;
				}
			}
		},
		components: {
			SidebarMenu,
			Header
		}
	};
</script>

<style scoped>
	#demo {
		padding-right: 250px;
		transition: 0.3s ease;
	}
	#demo.collapsed {
		padding-right: 10px;
	}
	#demo.onmobile {
		padding-right: 40px;
	}

	.sidebar-overlay {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: #000;
		opacity: 0.5;
		z-index: 900;
	}

	.demo {
		padding-top: 80px;
		margin-top: 45px;
	}

	pre {
		font-family: Consolas, monospace;
		color: #000;
		background: #fff;
		border-radius: 2px;
		padding: 15px;
		line-height: 1.5;
		overflow: auto;
	}

	@media  screen and (max-width:600px) {
		
		
	}
</style>
